var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2349_26541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94275 8.00021L12.4714 4.47154C12.7321 4.21087 12.7321 3.78954 12.4714 3.52887C12.2108 3.26821 11.7894 3.26821 11.5288 3.52887L8.00009 7.05754L4.47142 3.52887C4.21075 3.26821 3.78942 3.26821 3.52875 3.52887C3.26809 3.78954 3.26809 4.21087 3.52875 4.47154L7.05742 8.00021L3.52875 11.5289C3.26809 11.7895 3.26809 12.2109 3.52875 12.4715C3.65875 12.6015 3.82942 12.6669 4.00009 12.6669C4.17075 12.6669 4.34142 12.6015 4.47142 12.4715L8.00009 8.94287L11.5288 12.4715C11.6588 12.6015 11.8294 12.6669 12.0001 12.6669C12.1708 12.6669 12.3414 12.6015 12.4714 12.4715C12.7321 12.2109 12.7321 11.7895 12.4714 11.5289L8.94275 8.00021Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2349_26541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#374151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7b73a3d7.svg";
export { ForwardRef as ReactComponent };